// extracted by mini-css-extract-plugin
export default {"container":"TabsPage_container__0zIuX"};